import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Header from "../components/section/header"
import { StaticImage } from "gatsby-plugin-image"
import { graphql } from "gatsby"
// import Separator from "../utils/separator"
import RentalCard from "../components/section/RentalCard"

export default function Page({ data, location }) {
  // console.log(data)
  return (
    <Layout>
      <Seo pathname={location.pathname} title="Summar Villas" />
      <Header
        title="Summer Villas"
        image={
          <StaticImage
            alt="about-us"
            className="h-full w-full object-cover animate"
            src="../images/summer-rantals.jpg"
          />
        }
      />
      <Summer properties={data.allSanitySummerVilla.edges} />
    </Layout>
  )
}

const Summer = ({ properties }) => {
  return (
    <div>
      <div className="py-12 md:py-20 max-w-5xl w-11/12 xl:w-full mx-auto">
        <div>
          <h2 className="text-xl md:text-3xl capitalize pb-6">
            Villas – Home Away from Home
          </h2>
          <div className="space-y-6 leading-6 md:leading-9 text-xs md:text-base font-medium md:font-normal">
            <p>
              Below is just a sample, a sneak peek of the beautiful and elegant
              villas we represent for rent. From world heritage palaces to quiet
              country estates, exquisite style properties and access to the sea,
              we have a portfolio that covers everything to indulge your needs.
              Located all around the island, our villas are stunningly decorated
              and fully furnitured to allow you to spend an amazing stay
              surrounded by all the comfort and the relax you desire. Make us a
              request to receive personalized attention.
            </p>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-6 py-8">
          {properties.map((property, key) => {
            const { ref, ...other } = property.node
            return <RentalCard key={key} reference={ref} {...other} />
          })}
        </div>
      </div>
    </div>
  )
}

export const query = graphql`
  query {
    allSanitySummerVilla {
      edges {
        node {
          cover {
            asset {
              gatsbyImageData
            }
          }
          location_name
          name
          price
          ref
          beds
          guests
          services
          shortDescription
          slug {
            current
          }
        }
      }
    }
  }
`
